import { i as O } from "../isFunction-Dv8pj5Ka.js";
import { r as P, g as d } from "../_baseGetTag-D86WGQCZ.js";
import { r as h } from "../_overArg-_0pUmCsX.js";
import { r as m } from "../isObjectLike-DpBTCjvh.js";
var f, p;
function w() {
  if (p) return f;
  p = 1;
  var o = h(), t = o(Object.getPrototypeOf, Object);
  return f = t, f;
}
var l, g;
function y() {
  if (g) return l;
  g = 1;
  var o = P(), t = w(), r = m(), e = "[object Object]", n = Function.prototype, s = Object.prototype, i = n.toString, b = s.hasOwnProperty, v = i.call(Object);
  function j(c) {
    if (!r(c) || o(c) != e)
      return !1;
    var u = t(c);
    if (u === null)
      return !0;
    var a = b.call(u, "constructor") && u.constructor;
    return typeof a == "function" && a instanceof a && i.call(a) == v;
  }
  return l = j, l;
}
var L = y();
const q = /* @__PURE__ */ d(L);
function x(o) {
  let t = window, r, e = !1;
  if (O(o))
    r = o;
  else if (q(o))
    r = o.handler, t = o.target ?? t, e = o.options ?? e;
  else
    throw new Error(
      "Unexpected listener format, it's supposed to be an object or a function"
    );
  return {
    target: t,
    options: e,
    listener: r
  };
}
class S {
  constructor() {
    this.contexts = /* @__PURE__ */ new Map();
  }
  // context => eventType => Set<listeners>
  listen({
    target: t = window,
    type: r,
    listener: e,
    options: n,
    context: s
  }) {
    t.addEventListener(r, e, n);
    const i = this.storeListener(r, e, s);
    return () => {
      t.removeEventListener(r, e, n), i.delete(e);
    };
  }
  clear(t) {
    const r = this.contexts.get(t);
    if (!r) return !1;
    for (const [e, n] of r)
      for (const s of n) {
        const { target: i } = x(s);
        i.removeEventListener(e, s);
      }
    return this.contexts.delete(t);
  }
  storeListener(t, r, e) {
    this.contexts.has(e) || this.contexts.set(e, /* @__PURE__ */ new Map());
    const n = this.contexts.get(e);
    n.has(t) || n.set(t, /* @__PURE__ */ new Set());
    const s = n.get(t);
    return s.add(r), s;
  }
}
export {
  x as cookListener,
  S as default
};
